<template>
  <div class="checkbox-filter price-filter" v-if="rangeOption">
    <b-form-group>
      <b-form-input id="type-price" type="range" :min="rangeOption.min" :max="rangeOption.max" v-model="rangeVal"></b-form-input>
      <div class="summary">
        <span class="text min">{{$t('min')}}</span>
        <span class="text current" v-show="range">{{ range }} {{currencyCode}}</span>
        <span class="text max">{{$t('max')}}</span>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'Price',
  props: {
    attrCode: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      multipler: 3,
      range: false
    }
  },
  computed: {
    currencyCode () {
      return this.$store.getters['storeConfig/currencyCode']
    },
    rangeVal: {
      get () {
        let chosen = this.$store.state.listing.filters.chosen
        if (Object.keys(chosen).length && chosen[this.attrCode] && chosen[this.attrCode].length) {
          return this.$store.state.listing.filters.chosen[this.attrCode][0].split('_')[0]
        } else if (this.rangeOption) {
          return this.rangeOption.min
        } else {
          return this.range
        }
      },
      set (newValue) {
        this.range = newValue
        if ((newValue * 1) === this.rangeOption.max) {
          this.setRange(this.rangeOption.realMax)
        } else {
          this.setRange(newValue)
        }
        return newValue
      }
    },
    rangeOption () {
      let options = this.options
      let range = []
      if (options && options.length) {
        // CREATE ARRAY
        for (let i in options) {
          let value = options[i].value.replace('(', '').replace(')', '').split('..')
          // eslint-disable-next-line
          if (i == (options.length - 1)) {
            // is last get just start value
            value[1] = value[0] * this.multipler
          }
          range.push(...value)
        }
        let max = Math.max(...range)
        return {
          min: 1,
          realMax: max / this.multipler,
          max: max
        }
      } else {
        return false
      }
    }
  },
  methods: {
    setRange: debounce(function (value) {
      this.$store.commit('listing/updateTemporaryFilters', this.getFilterCompose(value))
    }, 500),
    getFilterCompose (newValue) {
      return { attrCode: this.attrCode, valueSelected: [`${newValue}_${this.rangeOption.max}`] }
    }
  }
}
</script>
